import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { TimelineItem } from '../../../api/timeline/useTimeline';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import BarChartIcon from '@material-ui/icons/BarChart';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import SportsHockeyIcon from '@material-ui/icons/SportsHockey';
import SettingsIcon from '@material-ui/icons/Settings';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PersonRemoveIcon from '@material-ui/icons/PersonAddDisabled';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EventIcon from '@material-ui/icons/Event';
import EditIcon from '@material-ui/icons/Edit';

import { format } from 'date-fns';
import { de } from 'date-fns/locale';

export const TimelineEntry = ({ item }: { item: TimelineItem }) => {
  const formattedDate = format(new Date(item.timestamp), 'dd.MM.yyyy, HH:mm', { locale: de });

  const getIcon = (type: string) => {
    switch (type) {
      case 'CHALLENGE_CREATED':
        return <SportsHockeyIcon style={{ color: '#1976d2' }} />;
      case 'GAME_RESULT_ENTERED':
        return <EmojiEventsIcon style={{ color: '#388e3c' }} />;
      case 'GAME_RESULT_EDITED':
        return <EditIcon style={{ color: '#ffa000' }} />; // orange-gelb für „bearbeitet"
      case 'RANKING_UPDATE':
        return <BarChartIcon style={{ color: '#f57c00' }} />;
      case 'CONFIGURATION_CHANGED':
        return <SettingsIcon style={{ color: '#6d4c41' }} />;
      case 'PLAYER_CREATED':
        return <PersonAddIcon style={{ color: '#009688' }} />;
      case 'PLAYER_DELETED':
        return <PersonRemoveIcon style={{ color: '#b71c1c' }} />;
      case 'PLAYER_ACTIVITY_CHANGED':
        return item.message.includes('inaktiv') ? (
          <BlockIcon style={{ color: '#b71c1c' }} />
        ) : (
          <CheckCircleIcon style={{ color: '#2e7d32' }} />
        );
      case 'CUP_START_TIME_CHANGED':
        return <EventIcon style={{ color: '#0288d1' }} />;
      case 'ADMIN_MESSAGE':
      default:
        return <NotificationsActiveIcon style={{ color: '#757575' }} />;
    }
  };

  return (
    <Paper
      elevation={1}
      style={{
        padding: '12px 16px',
        display: 'flex',
        gap: 12,
        alignItems: 'flex-start',
        backgroundColor: '#fefefe',
      }}
    >
      <Box pt={0.5}>{getIcon(item.type)}</Box>
      <Box>
        <Typography variant="body2" style={{ fontWeight: 500, lineHeight: 1.4 }}>
          {item.message}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {formattedDate}
        </Typography>
      </Box>
    </Paper>
  );
};
